import { render, staticRenderFns } from "./SelectWares.vue?vue&type=template&id=232658ca&scoped=true&"
import script from "./SelectWares.vue?vue&type=script&lang=js&"
export * from "./SelectWares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232658ca",
  null
  
)

export default component.exports